/// In every file you need this!
import $ from 'jquery';
//attach jquery to dom
window.jQuery = $;
window.$ = $;

import 'owl.carousel';

$(document).ready(function () {

    if ($(".image_slider")[0]) {
        var carousel = $(".image_slider .owl-carousel");
        carousel.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true, 
            dots: true,
            nav: false,
            smartSpeed: 1000,
            slideSpeed: 600,
            paginationSpeed: 500, 
            items: 1
        });
    }

    if ($(".events_single_slider")[0]) {
        var carousel = $(".events_single_slider .owl-carousel");
        carousel.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true, 
            dots: true,
            nav: false,
            responsiveClass: true,
            responsive: {
            0: {
                items: 1
            }
          }
        });
        $(".products_outer .owl_nav_products_carousel").on("click", function() {
        if ($(this).hasClass("prev")) {
                $(".owl-carousel button.owl-prev").trigger("click");
                console.log("clicked pre");
            } else if ($(this).hasClass("next")) {
                $(".owl-carousel button.owl-next").trigger("click");
                console.log("clicked next");
            }
        });
    }

    if ($(".did_you")[0]) {
        var carousel = $(".did_you .owl-carousel");
        carousel.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true,
            dots: true,
            nav: false,
			autoHeight:true,
            responsiveClass: true,
            responsive: {
            0: {
                items: 1
            }
          }
        });
        $(".products_outer .owl_nav_products_carousel").on("click", function() {
        if ($(this).hasClass("prev")) {
                $(".owl-carousel button.owl-prev").trigger("click");
                //console.log("clicked pre");
            } else if ($(this).hasClass("next")) {
                $(".owl-carousel button.owl-next").trigger("click");
                //console.log("clicked next");
            }
        });
    }

    if ($(".gallery_slider")[0]) {
        var carousel = $(".gallery_slider .owl-carousel");
        carousel.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true,
            dots: false,
            nav: false,
            responsiveClass: true,
            responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            992: {
                items: 4
            }
          }
        });
        $(".gallery_slider .owl_nav_gallery_carousel").on("click", function() {
        if ($(this).hasClass("prev")) {
                $(".gallery_slider .owl-carousel button.owl-prev").trigger("click");
                //console.log("clicked pre");
            } else if ($(this).hasClass("next")) {
                $(".gallery_slider .owl-carousel button.owl-next").trigger("click");
                //console.log("clicked next");
            }
        });
    }

    if ($(".services_mobile")[0]) {
        var carousel = $(".services_mobile .owl-carousel");
        carousel.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true,
            dots: true,
            nav: false,
            responsiveClass: true,
            responsive: {
            0: {
                items: 1
            },
            767: {
                items: 2
            }
          }
        });
        $(".services_mobile .owl_nav_services_carousel").on("click", function() {
        if ($(this).hasClass("prev")) {
                $(".services_mobile .owl-carousel button.owl-prev").trigger("click");
                //console.log("clicked pre");
            } else if ($(this).hasClass("next")) {
                $(".services_mobile .owl-carousel button.owl-next").trigger("click");
                //console.log("clicked next");
            }
        });
    }

    if ($(".events_slider")[0]) {
        var carousel = $(".events_slider .owl-carousel");
        carousel.owlCarousel({
            autoplay: false,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true,
            dots: true,
            nav: false,
            responsiveClass: true,
            responsive: {
            0: {
                items: 1
            },
            767: {
                items: 3
            },
            992: {
                items: 4
            }
          }
        });
        $(".events_slider .owl_nav_events_carousel").on("click", function() {
        if ($(this).hasClass("prev")) {
                $(".events_slider .owl-carousel button.owl-prev").trigger("click");
                //console.log("clicked pre");
            } else if ($(this).hasClass("next")) {
                $(".events_slider .owl-carousel button.owl-next").trigger("click");
                //console.log("clicked next");
            }
        });
    }

    if ($(".video_slider")[0]) {
        var carousel = $(".video_slider .owl-carousel");
        carousel.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true,
            dots: false,
            nav: true,
            responsiveClass: true,
            responsive: {
							0: {
	                items: 1
	            },
	            767: {
	                items: 2
	            },
	            992: {
	                items: 2
	            }
          }
        });
        $(".owl_nav_custom").on("click", function() {
        if ($(this).hasClass("prev")) {
                $(".video_slider .owl-carousel button.owl-prev").trigger("click");
                console.log("clicked pre");
            } else if ($(this).hasClass("next")) {
                $(".video_slider .owl-carousel button.owl-next").trigger("click");
                console.log("clicked next");
            }
        });
    }

	if ($(".inspire-slider")[0]) {
        var carousel = $(".inspire-slider .owl-carousel");
        carousel.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true,
            dots: false,
            nav: true,
            responsiveClass: true,
            responsive: {
							0: {
									items: 1
							},
							767: {
									items: 1
							},
							992: {
									items: 2
							},
							1024: {
									items: 2
							}
          }
        });
        $(".owl_nav_custom").on("click", function() {
        if ($(this).hasClass("prev")) {
                $(".video_slider .owl-carousel button.owl-prev").trigger("click");
                console.log("clicked pre");
            } else if ($(this).hasClass("next")) {
                $(".video_slider .owl-carousel button.owl-next").trigger("click");
                console.log("clicked next");
            }
        });
    }

    if ($(".where_your_money_goes")[0]) {
        var carousel = $(".where_your_money_goes .owl-carousel");
        carousel.owlCarousel({
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            loop: true,
            dots: true,
            items: 1,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false
        });
    }
});
